module.exports = "../study/imgs/maps/Nagano/S8/Hazard/Beach/Nagano_Beach_HadGEM2_RCP85_Mid.png";